module.exports = __webpack_public_path__ + "media/images/icon_list/comment-0ad5001629aea9a24f9ec61f8362c59f.svg";